import { Dispatch } from 'redux';
import { setHasInternet } from '../appActions';

export function isOffline() {
  return !window.navigator.onLine;
}

export const setConnectionListeners = (dispatch: Dispatch) => {
  window.addEventListener('offline', () => {
    dispatch(setHasInternet(false));
  });

  window.addEventListener('online', () => {
    dispatch(setHasInternet(true));
  });
};
